import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { format } from 'date-fns';

@Component({
    selector: 'date-as-long-renderer',
    template: ` <span> {{ value }} </span> `,
    styleUrls: ['./date-as-long-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateAsLongRendererComponent implements ICellRendererAngularComp {
    value!: string;

    constructor(private cd: ChangeDetectorRef) {}

    agInit(params: ICellRendererParams): void {
        const rawValue = params.getValue?.();
        this.value = rawValue ? format(new Date(rawValue), 'dd-MMM-yyyy') : '';
        params.setValue?.(this.value);
    }

    refresh(params: ICellRendererParams): boolean {
        const rawValue = params.getValue?.();
        this.value = rawValue ? format(new Date(rawValue), 'dd-MMM-yyyy') : '';
        params.setValue?.(this.value);
        this.cd.detectChanges();
        return true;
    }
}
